import * as React from 'react';

export interface Config extends Record<string, any> {}

export interface ConfigContextReturn {
  config: Config;
  getConfig: (key: string, defaultValue?: any) => any | undefined;
}

export const ConfigContext = React.createContext<ConfigContextReturn>({} as ConfigContextReturn);

interface ConfigProviderProps {
  config: Config | null | undefined;
}

/**
 * Typical usage within gui_defs view_react_field:
 * $field = new view_react_field();
 * $field->react_root = "FooBar";
 * $field->react_props = [
 *     "config" => [
 *         "foo" => "bar",
 *     ],
 * ];
 * $this->addField($tab, $col, $field);
 */
export const ConfigProvider: React.FC<ConfigProviderProps> = ({ config: _config, children }) => {
  const [config] = React.useState<Config>(_config ?? {});

  const getConfig = (key: string, defaultValue?: any) => {
    return config[key] ?? defaultValue;
  };

  return <ConfigContext.Provider value={{ config, getConfig }}>{children}</ConfigContext.Provider>;
};
